import { ConsumptionOriginEnum } from '../../../models/Enums/ConsumptionOriginEnum';
import { VisitPlaceholderTypeEnum } from '../../../models/Enums/VisitPlaceholderTypeEnum';

// stores 
import * as ProtocolsStore from '../../../redux/middleware/MedicalProtocolMiddleware';
import * as ProtocolConsumptionStore from '../../../redux/middleware/ProtocolConsumptionMiddleware';
import * as ProtocolConsumptionVisitStore from '../../../redux/middleware/ProtocolConsumptionVisit.Middleware';
import * as ContractsStore from '../../../redux/middleware/ContractMiddleware';
import * as PractitionersStore from "../../../redux/middleware/PractitionerMiddleware";
import * as ProvidersStore from "../../../redux/middleware/ProviderMiddleware";



// state
import { AppState } from '../../../redux/reducers';
import { ProtocolConsumption } from '../../../models/Entities/Protocols/ProtocolConsumption';
import { ProtocolConsumptionConceptValues } from '../../../models/Entities/Protocols/ProtocolConsumptionConceptValues';
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { Practitioner } from "../../../models/Entities/Practitioners/Practitioner";
import { Provider } from '../../../models/Entities/Provider/Provider';
import { ProtocolConsumptionVisit } from '../../../models/Entities/Protocols/ProtocolConsumptionVisit';
import { IConsumptionsFilters } from '../../../models/Filters/ConsumptionsFilters';
import { AzureFileTarget } from '../../../models/Entities/AzureFiles/AzureFileUpload';
import { AzureFileEntityTypeEnum } from '../../../models/Enums/AzureFileTypeEnum';
import { getProtocolSponsorStorageOwner, getProviderStorageOwner } from '../../../functions/AzureFileUpload.Functions';

//#region Props

interface IProps {
    ProtocolId: number | undefined;
    StageId: number | undefined;
    PatientNumberInProtocol: string | undefined;
    ProducerId: string | undefined;
    ProviderId: number | undefined;
    onChangeFilters: (filters: IConsumptionsFilters) => void;
}

interface ConnectedProps {
    isLoading: boolean;
    successLoading: boolean;
    error: string | null;

    haveConsumptionsToSettle: boolean;

    Consumptions: ProtocolConsumption[];
    protocol: Protocol | null;
    contract : Contract | null;
    Practitioners: Practitioner[];
    CurrentProvider: Provider | undefined;
 
    CurrentVisit: ProtocolConsumptionVisit | undefined;

    GetPersonByIdentifier: (identifier: string) => Practitioner | undefined;
    GetProtocolById: (protocolId: number) => Protocol | undefined;
}

interface MedicalServicesDispatchProps {
    GetMedicalProtocolById: typeof ProtocolsStore.actionCreators.GetMedicalProtocolById;
    GetAllMedicalProtocols: typeof ProtocolsStore.actionCreators.GetAllMedicalProtocols;
    GetAllProtocolConsumptionsByProtocol: typeof ProtocolConsumptionStore.ActionCreators.GetAllProtocolConsumptionsByProtocol;
    GetProtocolConsumptionToSettle: typeof ProtocolConsumptionStore.ActionCreators.GetProtocolConsumptionToSettle;
    DeleteProtocolConsumption: typeof ProtocolConsumptionStore.ActionCreators.DeleteProtocolConsumption;
    GetProviderConsumptions: typeof ProvidersStore.actionCreators.GetProviderConsumptions;
    GetAllProtocolContractAssociations: typeof ProtocolsStore.actionCreators.GetAllProtocolContractAssociations;
    GetContractById: typeof ContractsStore.actionCreators.GetContractById;
    GetAllPractitioners: typeof PractitionersStore.actionCreators.GetAllPractitioners;
    GetProviderById: typeof ProvidersStore.actionCreators.GetProviderById;
    GetProtocolVisitById: typeof ProtocolConsumptionVisitStore.actionCreators.GetProtocolVisitById;
    GetProtocolVisitByStageId: typeof ProtocolConsumptionVisitStore.actionCreators.GetProtocolVisitByStageId;
    GetAllConsumptionsByVisitId: typeof ProtocolConsumptionVisitStore.actionCreators.GetAllConsumptionsByVisitId;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    
    const practitioners = state.Practitioners?.list || [];

    const AuxProtocol: Protocol | null =  state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === ownProps.ProtocolId) ?? null;

    const AuxProvider: Provider | undefined = state.Provider?.list?.find((provider: Provider) => provider.id === ownProps.ProviderId) ?? undefined;

    // get first contract associated from protocol
    const AuxContractId = AuxProtocol?.contractAssociation?.contractId || null;

    const AuxContract: Contract | null = state.Contract?.list?.find((contract: Contract) => contract.id === AuxContractId) ?? null;

    const AuxPractitioners = state.Practitioners?.list || [];

    let AuxConsumptions: ProtocolConsumption[] = ownProps.ProviderId ? AuxProvider?.consumptions ?? [] : AuxProtocol?.consumptions ?? [];

    const AuxConsumptionVisit : ProtocolConsumptionVisit | undefined = AuxProtocol?.ConsumptionVisits?.find((visit: ProtocolConsumptionVisit) =>
        visit.contractStageId === ownProps.StageId && visit.patientNumberInProtocol === ownProps.PatientNumberInProtocol ) ?? undefined;

    if(ownProps.StageId !== undefined && ownProps.PatientNumberInProtocol !== undefined) {
        AuxConsumptions = AuxConsumptionVisit?.consumptions ?? [];
    }

    return {
        isLoading: AuxProtocol?.isGettingConsumptions || false,
        successLoading: state.MedicalProtocols?.LoadingAllConsumptionsSuccess || undefined,
        error: state.MedicalProtocols?.ErrorGettingAllConsumptions || null,
        
        haveConsumptionsToSettle: AuxProtocol?.consumptionsToSettle?.some((consumption: ProtocolConsumption) => consumption.status === 6),
        
        Consumptions: AuxConsumptions ? AuxConsumptions.sort(
            (a: ProtocolConsumption, b: ProtocolConsumption) => new Date(b.serviceDueDate).getTime() - new Date(a.serviceDueDate).getTime()
        ) : [],
        protocol: AuxProtocol,
        contract: AuxContract,
        Practitioners: AuxPractitioners,
        CurrentProvider: AuxProvider,

        CurrentVisit: AuxConsumptionVisit,

        GetPersonByIdentifier: (identifier: string) => GetPersonByIdentifier(practitioners, identifier),
        GetProtocolById: (protocolId: number) => state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === protocolId) || null
    }
};

export const mapDispatchToProps = {
    ...ProtocolsStore.actionCreators,
    ...ProtocolConsumptionStore.ActionCreators,
    ...ContractsStore.actionCreators,
    ...PractitionersStore.actionCreators,
    ...ProvidersStore.actionCreators,
    ...ProtocolConsumptionVisitStore.actionCreators,
};

//#region Azure file upload (provider files / sponsor payment proposals)

export type ConsumptionUploadMode = 'provider' | 'protocol';

export interface ConsumptionUploadConfig {
    mode: ConsumptionUploadMode | undefined;
    target: AzureFileTarget | undefined;
    /** i18n key explaining why the upload is disabled (owner data missing) */
    unavailableReasonKey: string | undefined;
}

/**
 * Which upload the list offers:
 *  - provider consumptions (ProviderId, no ProtocolId) → provider invoice / services performed, owner Provider.
 *  - protocol consumptions (ProtocolId, no StageId / ProviderId) → sponsor payment proposal,
 *    owner Sponsor = sponsor of the protocol contract, protocolId = ProtocolId.
 *  - any other usage (visit detail...) → no upload.
 */
export const getConsumptionUploadConfig = (
    ownProps: Pick<IProps, 'ProtocolId' | 'ProviderId' | 'StageId'>,
    contract: Pick<Contract, 'sponsors'> | null | undefined
): ConsumptionUploadConfig => {
    if (ownProps.ProviderId && !ownProps.ProtocolId) {
        const owner = getProviderStorageOwner(ownProps.ProviderId);
        return {
            mode: 'provider',
            target: owner ? { entityType: AzureFileEntityTypeEnum.Provider, entityId: ownProps.ProviderId, owner } : undefined,
            unavailableReasonKey: owner ? undefined : 'azureFileUpload.ownerUnavailable.provider',
        };
    }
    if (ownProps.ProtocolId && !ownProps.StageId && !ownProps.ProviderId) {
        const sponsorId = contract?.sponsors?.find((sponsor) => !!sponsor?.sponsorId)?.sponsorId;
        const owner = getProtocolSponsorStorageOwner(ownProps.ProtocolId, sponsorId);
        return {
            mode: 'protocol',
            target: owner ? { entityType: AzureFileEntityTypeEnum.Protocol, entityId: ownProps.ProtocolId, owner } : undefined,
            unavailableReasonKey: owner
                ? undefined
                : contract
                    ? 'azureFileUpload.ownerUnavailable.protocol'
                    : 'azureFileUpload.ownerUnavailable.loading',
        };
    }
    return { mode: undefined, target: undefined, unavailableReasonKey: undefined };
};

//#endregion


export const GetStatusDescription = (status: number): {description: string, class: string} => {

    /*
        NotSettled = 0,
        Pending = 1,
        Payee = 2,
        Settled = 3,
        Rejected = 4,
        Ignored = 5,
        ToSettle = 6,
        Invoiced = 7,
        PartialSettled = 8,

     */

    switch (status) {
        case 0:
            return {description: 'Pendiente de liquidación', class: 'status-not-settled'};
        case 1:
            return {description: 'Con saldo pendiente', class: 'status-pending'};
        case 2:
            return {description: 'Pagado', class: 'status-payee'};
        case 3:
            return {description: 'Liquidado', class: 'status-settled'};
        case 4:
            return {description: 'Rechazado', class: 'status-rejected'};
        case 5:
            return {description: 'Ignorado', class: 'status-ignored'};
        case 6:
            return {description: 'Por liquidar', class: 'status-to-settle'};
        case 7:
            return {description: 'Facturado', class: 'status-invoiced'};
        case 8:
            return {description: 'Parcialmente liquidado', class: 'status-partial-settled'};
        default:
            return {description: 'Unknown', class: 'status-unknown'};
    }
}

 // get person by identifier
const GetPersonByIdentifier = (persons: Practitioner[], identifier: string): Practitioner | undefined => {
  return persons.find((person: Practitioner) => person.userId === identifier);
}

export const GetRowClassByStatus = (status: number): string => {
    switch (status) {
        case 0:
            return ''; // 'status-not-settled-row';
        case 1:
            return ''; // 'status-pending-row';
        case 2:
            return 'status-payee-row';
        case 3:
            return 'status-settled-row';
        case 4:
            return ''; // 'status-rejected-row';
        case 5:
            return 'status-ignored-row';
        case 6:
            return 'status-to-settle-row';
        case 7:
            return 'status-invoiced-row';
        case 8:
            return 'status-partial-settled-row';
        default:
            return ''; // 'status-unknown-row';
    }
}

export const GetTypeOfServiceDescription = (typeOfService: number): string | undefined => {
    switch (typeOfService) {
        case 1:
            return undefined;
        case 2:
            return 'Adicional';
        case 3:
            return 'No Esperado';
        case 4:
            return 'No Realizado';
        default:
            return undefined;
    }
}

/**
 * Resolves the origin of a consumption for display. Values beyond the two the
 * business confirmed fall back to a neutral "other" rather than being labelled
 * as manual or system, which would state something we cannot back up.
 */
export type ConsumptionOriginVariant = 'system' | 'manual' | 'providerImport' | 'other';

export const GetConsumptionOrigin = (
    origin: number | undefined
): { variant: ConsumptionOriginVariant; label: string; labelKey: string } => {
    switch (origin) {
        case ConsumptionOriginEnum.System:
            return { variant: 'system', label: 'Generado por el sistema', labelKey: 'consumptionList.origin.system' };
        case ConsumptionOriginEnum.Manual:
            return { variant: 'manual', label: 'Cargado manualmente', labelKey: 'consumptionList.origin.manual' };
        // Spec 005: consumo de protocolo generado desde un consumo importado del archivo del proveedor.
        case ConsumptionOriginEnum.ProviderFileImport:
            return { variant: 'providerImport', label: 'Importado de proveedor', labelKey: 'consumptionList.origin.providerImport' };
        default:
            return { variant: 'other', label: 'Origen no informado', labelKey: 'consumptionList.origin.other' };
    }
};

/**
 * Visita que MedicalProtocol dejó a valor 0 porque ningún concepto del
 * contrato la liquida. Se reconoce por la marca del servidor; a falta de ella
 * (respuestas viejas) vale la combinación "con advertencia + sin concepto +
 * sin importe", que es exactamente lo que el backend produce en ese caso.
 */
export const isVisitPlaceholder = (
    item: Pick<ProtocolConsumption, 'visitPlaceholder' | 'markedAsHaveWarnings' | 'contractConceptId' | 'totalAmount'>
): boolean => {
    if (item.visitPlaceholder !== undefined && item.visitPlaceholder !== null) {
        return item.visitPlaceholder !== VisitPlaceholderTypeEnum.None;
    }
    return Boolean(item.markedAsHaveWarnings) && !item.contractConceptId && !(item.totalAmount > 0);
};

/**
 * Qué se le cuenta al analista sobre la alerta: el comentario del servidor si
 * lo hay, si no el texto genérico. Devuelve vacío cuando no hay nada que
 * advertir, para que el que llama no pinte un aviso sin contenido.
 */
export const getConsumptionAlert = (
    item: Pick<ProtocolConsumption, 'visitPlaceholder' | 'markedAsHaveWarnings' | 'warningsComments' | 'contractConceptId' | 'totalAmount'>,
    defaultPlaceholderText: string
): string => {
    const comment = (item.warningsComments || '').trim();
    if (isVisitPlaceholder(item)) return comment || defaultPlaceholderText;
    return item.markedAsHaveWarnings ? comment : '';
};

// ─── Importes con retención ──────────────────────────────────────────────────

const round2 = (value: number): number => Math.round(value * 100) / 100;

/** Retención de un valor de concepto: sólo cuenta si el valor la aplica. */
export const getConceptValueWithholding = (
    value: Pick<ProtocolConsumptionConceptValues, 'applyWithholding' | 'withholdingAmount'>
): number => (value.applyWithholding ? (value.withholdingAmount ?? 0) : 0);

export interface ConsumptionAmounts {
    /** Concepto principal, antes de retener. */
    mainGross: number;
    mainWithholding: number;
    /** Suma de los valores de concepto (overhead incluido: es uno más), antes de retener. */
    valuesGross: number;
    /** Retención de los valores: cada uno trae la suya ya calculada. */
    valuesWithholding: number;
    gross: number;
    /** Retención total: la del principal más la de cada valor que la aplica. */
    withholding: number;
    /** Lo que efectivamente se liquida: bruto − retención total. */
    net: number;
}

/**
 * Importes de un consumo tal como los liquida MedicalProtocols: el bruto es
 * el concepto principal más sus valores de concepto (el overhead viene como
 * un valor más, generado por el concepto porcentual del contrato), la
 * retención es la del principal más la de cada valor, y el neto es la
 * diferencia. Se recalcula acá a partir de las mismas partes que muestran las
 * columnas, en vez de leer TotalAmount (que ya trae los valores netos pero no
 * la retención principal), para que la fila cierre sola: neto = bruto − retención.
 */
export const getConsumptionAmounts = (
    item: Pick<ProtocolConsumption, 'amount' | 'withHolingAmount' | 'conceptValues'>
): ConsumptionAmounts => {
    const values = item.conceptValues ?? [];
    const mainGross = item.amount ?? 0;
    const mainWithholding = item.withHolingAmount ?? 0;
    const valuesGross = values.reduce((sum, value) => sum + (value.value ?? 0), 0);
    const valuesWithholding = values.reduce((sum, value) => sum + getConceptValueWithholding(value), 0);
    const gross = round2(mainGross + valuesGross);
    const withholding = round2(mainWithholding + valuesWithholding);
    return { mainGross, mainWithholding, valuesGross, valuesWithholding, gross, withholding, net: round2(gross - withholding) };
};

export interface ConceptValueColumnAmounts {
    count: number;
    gross: number;
    withholding: number;
    net: number;
    currencyCode: string | undefined;
}

/**
 * Importes de la columna de un concepto: todos los valores con ese nombre
 * (el mismo concepto puede venir con distinto id entre adendas), netos de su
 * retención.
 */
export const getConceptValueColumnAmounts = (
    item: Pick<ProtocolConsumption, 'conceptValues'>,
    conceptName: string
): ConceptValueColumnAmounts => {
    const matches = (item.conceptValues ?? []).filter(value => value.contractConceptName === conceptName);
    const gross = round2(matches.reduce((sum, value) => sum + (value.value ?? 0), 0));
    const withholding = round2(matches.reduce((sum, value) => sum + getConceptValueWithholding(value), 0));
    return { count: matches.length, gross, withholding, net: round2(gross - withholding), currencyCode: matches[0]?.currencyCode };
};
